import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsRepeat"><Path d="M3.5 13.5V4.5H16" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 1.5L16.5 4.5L13.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 10.5V19.5H8" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 22.5L7.5 19.5L10.5 16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowsRepeat;
